import { TestRouteSection } from './TestsRouter';

/**
 * Generates a registry of test routes for the application.
 * Add your component here if you want to develop them out of the main application.
 *
 * @returns {TestRouteSection[]} An array of test route sections, each containing a key, name, path segment, and an array of tests.
 */
export const testsRoutesRegistry = (): TestRouteSection[] => [];
